import type { RegisterError } from '@/features/v2/auth/register/actions/result';
import { userUIStore } from '@/stores/userUIStore';

export const notifyRegisterError = ({ code, message }: RegisterError): void => {
  userUIStore.getState().setAlert({
    message,
    type: 'error',
    show: true,
    duration: code === 'device_blocked' ? 5000 : 3000,
  });
};
